import classnames from 'classnames';
import React from 'react';

import { Button } from '@/design-system/atoms/Button';
import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { TextField } from '@/design-system/atoms/Forms/TextField';
import { Text } from '@/design-system/atoms/Text';
import { Theme } from '@/design-system/atoms/Theme';
import { Title } from '@/design-system/atoms/Title';

import styles from './JobSearchBanner.module.scss';

export const JobSearchBanner = ({
    testId,
    theme = Theme.NAME.TREATMENTS_AND_SERVICES,
    title,
    body,
    text,
    cta,
    buttonType,
    isFullWidth = false,
    className,
    analytics,
    id,
    searchTermFieldPlaceholder = '',
    ...props
}) => {
    const handleFormSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const searchTerm = formData.get('jobSearchInput');

        if (cta?.href && searchTerm) {
            const encodedValue = encodeURIComponent(searchTerm).replace(/%20/g, '+');
            const fullUrl = `${cta?.href}${encodedValue}`;
            window?.open(fullUrl, cta?.target || '_self', 'noopener,noreferrer');
        }
    };

    return (
        <section
            id={id}
            data-testid={testId}
            className={classnames(styles['job-search-banner'], className && styles[className])}
            {...props}
        >
            <ContentContainer isFullWidth={isFullWidth}>
                <Theme
                    name={theme}
                    className={classnames(
                        styles['job-search-banner__main'],
                        !isFullWidth && styles[`job-search-banner__main--rounded`],
                    )}
                >
                    <ContentContainer isFullWidth={!isFullWidth}>
                        <div className={styles['job-search-banner__content']}>
                            <div className={styles['job-search-banner__description']}>
                                <div className={styles['job-search-banner__title']}>
                                    <Title
                                        tag="h2"
                                        variant={Title.VARIANT.H4}
                                        content={title}
                                        lineClamp={{ sm: 3, lg: 2 }}
                                    />
                                </div>
                                {body && (
                                    <div className={styles['job-search-banner__body']}>
                                        <Text
                                            variant={Text.VARIANT.T2}
                                            content={body}
                                            lineClamp={{ sm: 3, lg: 2 }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className={styles['job-search-banner__form']}>
                                <form onSubmit={handleFormSubmit}>
                                    <TextField
                                        isRequired
                                        label={searchTermFieldPlaceholder}
                                        name="jobSearchInput"
                                        validationBehavior={'native'}
                                    />
                                    <Button
                                        fullWidth={{ md: true }}
                                        label={cta.label}
                                        ariaLabel={cta.ariaLabel}
                                        buttonStyle={
                                            buttonType === 'primary'
                                                ? Button.STYLE.PRIMARY
                                                : Button.STYLE.SECONDARY
                                        }
                                        className={styles['job-search-banner__button']}
                                        type="submit"
                                        analytics={{
                                            componentName: 'Job Search Banner',
                                            componentTitle: title,
                                            ...analytics,
                                        }}
                                    />
                                </form>
                            </div>
                        </div>
                    </ContentContainer>
                </Theme>
            </ContentContainer>
        </section>
    );
};

export default JobSearchBanner;
